import React, { useEffect, useState } from "react";
import { goUsers, allUser } from "../../Components/Apis/apis";
import SideBar from "../../Components/Navbar/Sidebar";
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import "./style.css";
import { Dropdown, DropdownButton } from "react-bootstrap";

const Users = () => {
  const [year, setYear] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [user, setUser] = useState([]);
  const [alluser, setallUser] = useState([]);
  const [userfilter, setUserfilter] = useState([]);
  const users = async () => {
    const data = await goUsers();

    data.map((el) => {
      el["year"] = el.datecreated.slice(0, 4);
      el["monthwithyear"] = el.datecreated.slice(0, 7);
    });
    setUser(data);
  };
  const allUsers = async () => {
    const data = await allUser();

    data.map((el) => {
      el["year"] = el.datecreated.slice(0, 4);
      el["monthwithyear"] = el.datecreated.slice(0, 7);
    });
    setallUser(data);
    setUserfilter(data);
  };

  useEffect(() => {
    users();
    allUsers();
  }, []);
  const allyaers = user.map((el) => el.year);
  const yearss = [...new Set(allyaers)];
  const years = yearss.filter((el) => el !== "0000");

  const currentYear = new Date().getFullYear();

  const filterOrder = async () => {
    let data;
    if (year == "") {
      data = user.filter((el) => el.year == currentYear);
    } else {
      data = user.filter((el) => el.year == year);
    }
    setFilterData(data);
  };

  const filterUser = async () => {
    let data;
    if (year == "") {
      data = alluser.filter((el) => el.year == currentYear);
    } else {
      data = alluser.filter((el) => el.year == year);
    }
    setUserfilter(data);
  };

  useEffect(() => {
    filterOrder();
    filterUser();
  }, [user, year, allUser]);

  const jan = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-01`
  );
  const feb = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-02`
  );
  const mar = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-03`
  );
  const apr = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-04`
  );
  const may = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-05`
  );
  const jun = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-06`
  );
  const jul = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-07`
  );
  const aug = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-08`
  );
  const sep = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-09`
  );
  const oct = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-10`
  );
  const nov = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-11`
  );
  const dec = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-12`
  );

  const janUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-01`
  );
  const febUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-02`
  );
  const marUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-03`
  );
  const aprUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-04`
  );
  const mayUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-05`
  );
  const junUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-06`
  );
  const julUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-07`
  );
  const augUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-08`
  );
  const sepUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-09`
  );
  const octUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-10`
  );
  const novUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-11`
  );
  const decUser = userfilter.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-12`
  );

  const Category = {
    labels: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],

    datasets: [
      {
        label: "Users",
        fill: false,
        color: "green",
        borderWidth: 2,
        pointRadius: 2,
        data: [
          janUser.length,
          febUser.length,
          marUser.length,
          aprUser.length,
          mayUser.length,
          junUser.length,
          julUser.length,
          augUser.length,
          sepUser.length,
          octUser.length,
          novUser.length,
          decUser.length,
        ],
      },
      {
        label: "Order from user",
        fill: true,
        color: "red",
        borderWidth: 2,
        pointRadius: 2,
        data: [
          jan.length,
          feb.length,
          mar.length,
          apr.length,
          may.length,
          jun.length,
          jul.length,
          aug.length,
          sep.length,
          oct.length,
          nov.length,
          dec.length,
        ],
      },
    ],
  };

  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages">
        <div className="page-title">
          <h2>
            Total users
            <div className="float-end me-4">
              {" "}
              <DropdownButton
                title={year ? <>Year {year}</> : <> Select year </>}
                id="select-media-box"
                onSelect={(e) => setYear(e)}
                className="  ms-2"
              >
                {years.map((el, i) => (
                  <Dropdown.Item eventKey={el} className="" key={i}>
                    {el}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </div>
          </h2>
        </div>
        <div className="main-div">
          <Bar data={Category} />
        </div>
      </div>
    </div>
  );
};

export default Users;
